import "./photo-zone-style.css";
import {Swiper, SwiperSlide} from "swiper/react";
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

import {PhotoZoneProps} from "./PhotoZoneProps";
import {ZoneSliderConfig} from "./ZoneSliderConfig";
export const PhotoZone = (slide: PhotoZoneProps) => {
    return(
        <section className={"PhotoZone"} id={'photo-zone'}>
            <div className={"container"}>
                <h1 className={'section__title'}>Фото зоны</h1>
                <Swiper {...ZoneSliderConfig} className={'swiper'}>
                    {slide.zone.map((slide, index) => (
                        <SwiperSlide key={index} className={'swiper'}>
                            <img src={slide.img} alt={slide.alt} loading={"lazy"}/>
                        </SwiperSlide>
                    ))}
                    <div className="swiper-button-prev"></div>
                    <div className="swiper-button-next"></div>
                </Swiper>
            </div>
        </section>
    );
}